import { render, staticRenderFns } from "./ListMailMega.vue?vue&type=template&id=5972e55f&scoped=true&"
import script from "./ListMailMega.vue?vue&type=script&lang=js&"
export * from "./ListMailMega.vue?vue&type=script&lang=js&"
import style0 from "./ListMailMega.vue?vue&type=style&index=0&id=5972e55f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5972e55f",
  null
  
)

export default component.exports